module.exports = __webpack_public_path__ + "static/media/kiwi-biosciences.d01358b9.png";